export default __webpack_public_path__ + "static/media/949.a11bd5c7.png";